import { render, staticRenderFns } from "./exemptions.vue?vue&type=template&id=04d012b8&"
import script from "./exemptions.vue?vue&type=script&lang=js&"
export * from "./exemptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports